import {
  Flex,
  StyledTable,
  StyledTd,
  StyledTh,
  StyledTr,
} from "../../../styled";
import {
  formatDateTimeUTC,
  INMEASection,
  sortNMEARowsByTime,
} from "./NMEAAutomationModal.utils";
import { Checkbox, Grid, Text } from "@mantine/core";
import { getColValue } from "../../../pages/Reports/Report/Report.utils";
import { useSelector } from "../../../redux/hooks";
import { useIsNewEntry, useTheme } from "../../../hooks";

interface Props {
  section: INMEASection;
  sectionIndex: number;
  selectedSections: number[][];
  setSelectedSections: (selectedSections: number[][]) => void;
  onlyOneAllowed: boolean;
}

const NMEAAutomationModalPreview = ({
  section,
  sectionIndex,
  selectedSections,
  setSelectedSections,
  onlyOneAllowed,
}: Props) => {
  const theme = useTheme();
  const { latestEntry, lbentry } = useSelector(state => state.generatorSlice);
  const isNewEntry = useIsNewEntry();
  const isSavedData = lbentry?.NMEAData && lbentry.NMEAData.length > 0;
  const handleToggle = (index: number) => {
    let updatedSections = [...selectedSections];
    const isBlockedByStatus = !(
      (latestEntry.autosave && latestEntry.status === 0) ||
      isNewEntry
    );

    if (
      updatedSections[sectionIndex]?.includes(index) &&
      !(
        isSavedData &&
        isBlockedByStatus &&
        !!lbentry?.NMEAData?.[sectionIndex]?.rows[index]?.selected
      )
    ) {
      updatedSections[sectionIndex] = updatedSections[sectionIndex].filter(
        i => i !== index,
      );
    } else {
      if (!updatedSections[sectionIndex]) {
        updatedSections[sectionIndex] = [];
      }
      if (onlyOneAllowed) {
        // Only clear the current section, not all sections
        updatedSections[sectionIndex] = [];
      }
      updatedSections[sectionIndex].push(index);
    }
    setSelectedSections(updatedSections);
  };

  const hoverStyle = {
    transition: "transform 0.2s ease-in-out",
    "&:hover": {
      transform: "scale(1.03)",
      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
      zIndex: 1,
      cursor: "pointer",
    },
  };

  const sortedRows = sortNMEARowsByTime(section.rows);
  return (
    <Grid columns={2} p={10}>
      {sortedRows.map((row, index) => {
        return (
          <Grid.Col
            span={1}
            onClick={() => handleToggle(index)}
            sx={hoverStyle}
            key={index}>
            <StyledTable>
              <StyledTr>
                <StyledTh colSpan={2}>
                  <Flex align="center" gap={30}>
                    <Checkbox
                      checked={selectedSections[sectionIndex]?.includes(index)}
                      onChange={() => handleToggle(index)}
                    />
                    <Flex direction="column" justify="flex-start" gap={0}>
                      {row.dateTimeUTC || row.dateTimeLT ? (
                        <>
                          {row.dateTimeLT && <Flex>{row.dateTimeLT}</Flex>}
                          {row.dateTimeUTC && <Flex>{row.dateTimeUTC}</Flex>}
                        </>
                      ) : (
                        formatDateTimeUTC(row.dateTime)
                      )}
                    </Flex>
                  </Flex>
                </StyledTh>
              </StyledTr>
              <StyledTr>
                <StyledTh>Column</StyledTh>
                <StyledTh>Data</StyledTh>
              </StyledTr>
              {Object.values(row.cols).map(
                (col, colIdx) =>
                  col.unit !== "24lock" && (
                    <StyledTr key={colIdx}>
                      <StyledTd>{col.name?.replaceAll("<br>", " ")}</StyledTd>
                      <StyledTd>{getColValue(col)}</StyledTd>
                    </StyledTr>
                  ),
              )}
            </StyledTable>
          </Grid.Col>
        );
      })}
    </Grid>
  );
};
export default NMEAAutomationModalPreview;
